import { Table, Space, Typography, Tag, Badge, Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import DescargarActaButton from "./DescargarActaButton";
import EntregaLineasExpand from "./EntregaLineasExpand";

const { Text } = Typography;

const formatNumber = (value) => new Intl.NumberFormat("es-CO").format(Number(value || 0));

const rowKeyDe = (r) => `${r.oid_participante}-${r.tipo_entrega}-${r.fecha_entrega}`;

export default function EntregasPOTable({ data = [], loading, pagination, onTableChange, onDeleteActa, onDatosActaGuardados, permissionDelete, userLogin }) {

  const columns = [
    {
      title: "Entidad",
      width: 260,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Space>
            <Text strong ellipsis>{record.nombre_entrega}</Text>
            <Tag color={record.tipo_entrega_texto === "Participante" ? "blue" : "green"}>
              {record.tipo_entrega_texto}
            </Tag>
          </Space>
          <Text type="secondary">
            {record.tipo_entrega_texto === "Participante" ? `CC ${record.identificacion}` : `NIT ${record.identificacion}`}
          </Text>
        </Space>
      )
    },
    {
      title: "Proyecto / Ubicación",
      width: 260,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Space>
            <Tag color="blue">{record.codigo}</Tag>
            <Text type="secondary" ellipsis>{record.proyecto}</Text>
          </Space>
          <Text type="secondary">{record.municipio}, {record.departamento}</Text>
        </Space>
      )
    },
    {
      title: "Líneas",
      width: 90,
      align: "center",
      render: (_, record) => <Badge count={record.num_lineas} showZero color="#042956" />
    },
    {
      title: "Cantidad total",
      dataIndex: "total_cantidad",
      width: 120,
      align: "center",
      render: (value) => <Text strong>{formatNumber(value)}</Text>
    },
    {
      title: "Tipo acta",
      dataIndex: "tipo_acta",
      width: 100,
      render: (value) => <Tag>{value || "Parcial"}</Tag>
    },
    {
      title: "Fecha",
      dataIndex: "fecha_entrega",
      width: 130,
      render: (value) => (value ? dayjs(value).format("DD MMM YYYY") : "")
    },
    {
      title: "Acciones",
      fixed: "right",
      align: "center",
      width: 110,
      render: (_, record) => (
        <Space>
          <DescargarActaButton record={record} userLogin={userLogin} onDatosGuardados={onDatosActaGuardados} />
          {permissionDelete && (
            <Popconfirm
              title="Eliminar acta completa"
              description={`Se eliminarán las ${record.num_lineas} línea(s) de esta acta. ¿Continuar?`}
              onConfirm={() => onDeleteActa(record)}
              okText="Sí"
              cancelText="No"
            >
              <Button danger size="small" icon={<DeleteOutlined />} />
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey={rowKeyDe}
      bordered
      loading={loading}
      columns={columns}
      dataSource={data}
      scroll={{ x: 1150 }}
      onChange={onTableChange}
      expandable={{
        expandedRowRender: (record) => <EntregaLineasExpand record={record} />
      }}
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        showTotal: (total) => `Total actas: ${total}`
      }}
    />
  );
}
